<template>
    <v-layout fluid v-resize="onResize">
        <v-card class="mx-auto" elevation="4" width="100%">
            <h2 class="text-center">Punch System</h2>
            <v-divider />

            <v-row no-gutters class="text-center">
                <v-col cols="6" class="subtitle centerInfo">
                    Welcome {{ currentUser }}
                </v-col>
                <v-col>
                    <v-row no-gutters>
                        <v-col cols="12" class="subtitle">
                            {{ currentDate }}
                        </v-col>
                        <v-col cols="12" class="timer">
                            {{ currentTime }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider />
            <div class="text-center subtitle my-2">Active</div>
            <div class="px-2">
                <EasyDataTable
                    v-model:items-selected="selectedProjects"
                    buttons-pagination
                    :headers="table.headers"
                    :items="table.items"
                    :body-text-direction="bodyTextDirection"
                    :header-text-direction="bodyTextDirection"
                    table-class-name="customize-table"
                    :table-height="windowSize.y - 740"
                    :rows-items="[10, 25, 50, 100]"
                    :rows-per-page="10"
                    theme-color="#242939"
                    :loading="loading"
                >
                    <template #loading>
                        <v-progress-circular
                            color="blue-lighten-3"
                            indeterminate
                            :size="120"
                            class="mt-4"
                        >
                            <v-img
                                src="/images/d3_connect.png"
                                :size="10"
                                class="loading-spinner"
                            ></v-img
                        ></v-progress-circular>
                    </template>
                </EasyDataTable>
            </div>

            <v-row class="text-center my-2">
                <v-col cols="6">
                    <v-btn
                        variant="elevated"
                        color="blue"
                        size="x-large"
                        class="lgBtn"
                        :loading="loadingLogOut"
                        @click="logOut()"
                    >
                        Log Out
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn
                        v-if="this.selectedProjects.length === 0"
                        variant="elevated"
                        color="green"
                        size="x-large"
                        class="lgBtn"
                        @click="showActivityMenu()"
                    >
                        Start Activity
                    </v-btn>
                    <v-btn
                        v-else
                        variant="elevated"
                        color="red"
                        size="x-large"
                        class="lgBtn"
                        :loading="loadingStop"
                        @click="stopActivity()"
                    >
                        Stop Activity
                    </v-btn>
                </v-col>
            </v-row>

            <v-fade-transition>
                <div
                    v-show="completedTable.items.length > 0"
                    class="text-center"
                >
                    <v-row no-gutters>
                        <v-col cols="12" style="background-color: ">
                            <div class="subtitle my-2">
                                You Have Finished The Following
                            </div>
                        </v-col>

                        <v-col
                            cols="2"
                            v-for="(item, index) in completedTable.headers"
                        >
                            <b>{{ item }}</b>
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-row
                        v-for="(row, index) in completedTable.items"
                        class="my-1"
                    >
                        <v-col cols="2">
                            {{ row.ProjectName }}
                        </v-col>
                        <v-col cols="2">
                            {{ row.FixtureNumber }}
                        </v-col>
                        <v-col cols="2">
                            {{ row.ProcessName }}
                        </v-col>
                        <v-col cols="2">
                            {{ row.ClockIn }}
                        </v-col>
                        <v-col cols="2">
                            {{ row.ClockOut }}
                        </v-col>
                        <v-col cols="2">
                            {{ row.TimeSpent }}
                        </v-col>
                    </v-row>
                </div>
            </v-fade-transition>
        </v-card>
    </v-layout>

    <v-dialog
        v-model="activityMenu"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
    >
        <StartActivity @hideActivityMenu="hideActivityMenu" />
    </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import StartActivity from "./SartActivity.vue";

export default {
    name: "DPAM_Punch",
    components: { StartActivity },
    emits: ["showSnackbar"],
    data() {
        return {
            currentUser: "",
            currentUserID: null,
            currentDate: moment().format("DD/MM/YYYY"),
            currentTime: moment().format("HH:mm:ss"),
            table: {
                headers: [
                    {
                        text: "Project Name",
                        value: "ProjectName",
                    },
                    {
                        text: "Fixture Name",
                        value: "FixtureName",
                    },
                    {
                        text: "Fixture Number",
                        value: "FixtureNumber",
                    },
                    {
                        text: "Process Name",
                        value: "ProcessName",
                    },
                    {
                        text: "Clock In",
                        value: "ClockIn",
                    },
                ],
                items: [],
            },
            windowSize: {
                x: 0,
                y: 0,
            },
            selectedProjects: [],
            bodyTextDirection: "center",
            loading: false,
            loadingStop: false,
            loadingLogOut: false,
            completedTable: {
                headers: [
                    "Project Name",
                    "Fixture Number",
                    "Process Name",
                    "Clock In",
                    "Clock Out",
                    "Time Spent",
                ],
                items: [],
            },
            activityMenu: false,
        };
    },
    async created() {
        try {
            this.loading = true;
            await axios
                .get(route("api.getPunchSystemUserInfo"))
                .then((response) => {
                    this.currentUser = response.data.Name;
                    this.currentUserID = response.data.ID;
                    this.getActive();
                });
        } catch (err) {
            console.log(err);
        }
    },
    async mounted() {
        // this.getActive();
        setInterval(this.updateTime, 1000); // Update time every second
    },
    watch: {},
    computed: {},
    methods: {
        async getActive() {
            try {
                this.loading = true;
                await axios
                    .get(
                        route("api.getAllUserActiveProjectFixtures", {
                            ID: this.currentUserID, // 1,
                        })
                    )
                    .then((response) => {
                        this.table.items = response.data.data;
                        this.loading = false;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        showActivityMenu() {
            this.activityMenu = true;
        },
        hideActivityMenu() {
            this.activityMenu = false;
        },
        async getHistory() {
            try {
                await axios
                    .get(
                        route("api.getHistoryProjectFixturesByID", {
                            ID: this.selectedProjects[0].ID,
                        })
                    )
                    .then((response) => {
                        this.completedTable.items = response.data.data;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async stopActivity() {
            this.loadingStop = true;

            // Check for multiple selections
            if (this.selectedProjects.length > 1) {
                let msgData = {
                    msg: "ERROR: Please Select 1 Activity to Stop",
                    color: "error",
                };
                this.$emit("showSnackbar", msgData);
                this.loadingStop = false;
                return;
            }

            try {
                await axios
                    .post(
                        route("api.finishActivities", {
                            ProjectLogID: this.selectedProjects[0].ID,
                        })
                    )
                    .then((response) => {
                        if (response.data === true) {
                            this.getHistory();
                            this.selectedProjects = [];
                            this.getActive();
                            setTimeout(() => {
                                this.completedTable.items = [];
                            }, 6000);
                        }
                    });
            } catch (err) {
                console.log(err);
            }
            this.loadingStop = false;
        },
        async logOut() {
            this.loadingLogOut = true;
            try {
                await axios
                    .post(route("api.punch-system-logout"))
                    .then((response) => {
                        let msgData = {
                            msg: "Logout Succesful",
                            color: "success",
                        };
                        this.$emit("showSnackbar", msgData);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            window.location.href = route("log-in-punch");
                        }, 1000);
                    });
            } catch (err) {
                console.log(err);
                this.loadingLogOut = false;
            }
        },
        updateTime() {
            this.currentTime = moment().format("HH:mm:ss");
        },
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },
    },
};
</script>
<style scoped>
.subtitle {
    font-weight: bolder;
    font-size: 1.5em;
}
.centerInfo {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
}
.timer {
    font-weight: bold;
    font-size: 2em;
    color: #2196f3;
}
.customize-table {
    --easy-table-header-font-size: 15px;
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 63px;
    --easy-table-body-row-font-size: 16px;

    --easy-table-footer-background-color: #ffffff;
    --easy-table-footer-font-color: #242939;
    --easy-table-footer-font-size: 15px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 55px;

    --easy-table-rows-per-page-selector-width: 75px;
    --easy-table-rows-per-page-selector-option-padding: 15px;

    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-loading-mask-background-color: #ffffff;
}
:deep(.vue3-easy-data-table__header .easy-checkbox:first-child) {
    display: none;
}
.lgBtn {
    width: 75%;
    min-height: 10vh;
}
.lgBtn :deep(.v-btn__content) {
    font-size: 1.5em;
    text-transform: none;
    text-wrap: wrap;
}
:deep(.easy-data-table__rows-selector) {
    z-index: 1;
}
:deep(.v-snackbar__content) {
    font-size: 1.25em;
    text-align: center;
}
</style>
